import { request } from "@/plugins/axios";
export default {
  getInfo(query) {
    return request({
      url: "/account/userinfo",
      method: "get",
      params: query,
    });
  },
  refreshToken(data) {
    return request({
      url: "/account/refresh_token",
      method: "post",
      data,
    });
  },
  getApplyStatus(params) {
    return request({
      url: "/account/cert_times_info",
      method: "get",
      params,
    });
  },
  checkCode(data) {
    return request({
      url: "/account/verify_code",
      method: "post",
      data,
    });
  },
  checkIsTrial() {
    return request({
      url: "/account/trial_info",
      method: "get",
    });
  },

  applyReal(data) {
    return request({
      url: "/account/cert",
      method: "post",
      data,
    });
  },

  modifyPsd(data) {
    return request({
      url: "/account/modify_password",
      method: "put",
      data,
    });
  },
};
